var exports = {
  "k": "xae11d333--a7a700--container",
};

module.exports = exports;
